import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HeatwaveDataService } from '../heatwave-data.service';
import { forkJoin, Subject } from 'rxjs';
import { UtilsService } from 'src/app/utils/utils.service';
import { AgricultureMapConstants } from 'src/app/main/constants/dims-map-constants';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import * as Highcharts from 'highcharts';
import { isNullOrUndefined, log } from 'util';
import { LOCATION_HIE } from '../heatwave-map/heatwave-map-constants';
import { AccuracyPopupDataTableComponent } from 'src/app/main/shared/accuracy-popup-data-table/accuracy-popup-data-table.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { HeatwaveMapService } from '../heatwave-map/heatwave-map.service';
import { takeUntil } from 'rxjs/operators';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { InfomodalComponent } from 'src/app/main/shared/infomodal/infomodal.component';
import { isEmptyObject } from 'jquery';

@Component({
  selector: 'app-heatwave-infobox',
  templateUrl: './heatwave-infobox.component.html',
  styleUrls: ['./heatwave-infobox.component.scss']
})
export class HeatwaveInfoboxComponent implements OnInit {

  @ViewChild("container", { read: ElementRef, static: false }) public container: ElementRef;
  today: Date = new Date();
  ACTUAL_URL = "heatWatches/getActualHeatWaveCount";
  ACCURACY_URL = "hw/getHWAccuracyData";
  DISTRICT_URL = "heatWatches/getHeatWatchesCount";
  queryParams: any = {};
  selectedSource: any = 'IMD_LONG_RANGE'
  stateData: any;
  selectedState: any;
  selectedDistrict: string = '';
  selectedLocType: any;
  tableDataMandal: any;
  chartData: any;
  formattedChartData: any;
  blocksArray: any;
  count: any;
  highcharts = Highcharts;
  showChart: boolean = true;
  dates: string[] = [];
  tableRows: any[] = [];
  dataCount = {
    severeHeatwave: null,
    heatWave: null,
    normal: null,
    count: null,
    accuracy: null
  }  // chartOptions: Highcharts.Options;
  actualData: any;
  inputForBreadcrumb: any = [];
  categoryList: {};
  filteredData: { normal: any; heat_waves: any; severe_heat_waves: any; };
  showLastLevelTable: boolean = false
  totalCategoryCount: any;
  type: any;
  categoryTypes: any;
  selectedTimeStamp: any;
  hwCountTableData: any;
  hwCatagoryTableData: any;
  selectedComponent: string;
  destroy: any = new Subject();
  selectedParams: any;
  heatWatchesMap: { [uuid: string]: { heatwave: number; severeHeatwave: number } } = {};
  forecastDateLabel: string = '';
  subscriptions: any[] = [];
  populationExposureData: any = null;
  popExposureForDate: { normal: number; heat_waves: number; severe_heat_waves: number } = { normal: 0, heat_waves: 0, severe_heat_waves: 0 };
  selectedViewType: any = 'BLOCK'
  showSpinner: boolean = false
  isPdfDownloading: boolean = false

  constructor(private route: ActivatedRoute,
    private dataSrv: HeatwaveDataService,
    private utils: UtilsService,
    public gisMapComp: GisDimsMapComponent,
    private router: Router,
    private modalService: NgbModal,
    private hwMapSrv: HeatwaveMapService
  ) {
    this.selectedComponent = router.url.split('/')[2];
  }

  ngOnInit() {
    const selectedParamsRef = this.utils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams['params'] = params;
      } else {
        this.queryParams['params'] = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
      }
      this.selectedLocType = this.queryParams['params']['locType']
      this.showSpinner = true
      // Keep the DISTRICT/BLOCK selection across source change and drilldown (District level is always BLOCK)
      // this.selectedViewType = 'BLOCK'
      this.selectedViewType = this.hwMapSrv.getHeatwaveViewType(this.queryParams['params'])
      this.getHeirarchyData();
      this.getPopulationExposureData();
      if (this.queryParams['params'].locType == 'COUNTRY' || this.queryParams['params'].locType == 'STATE') {
        this.getStateData();
      } else if (this.queryParams['params'].locType == 'DISTRICT') {
        this.getDistrictData();
        this.setLastLevelTableData()
      }
    });
    const metaDataRef = this.utils.heatwaveMetaData.subscribe(data => {
      if (data && data[this.selectedViewType]) {
        this.dataCount = data[this.selectedViewType];
      }
    });
    // Sync population exposure % whenever the playbar date changes (Country/State/District)
    const timeStampRef = this.utils.getTimeStamp().subscribe((date: any) => {
      if (date) {
        this.selectedTimeStamp = date.toString();
        this.updatePopExposureForDate();
      }
    });
    this.subscriptions.push(selectedParamsRef);
    this.subscriptions.push(metaDataRef);
    this.subscriptions.push(timeStampRef);
  }

  getHeirarchyObj() {
    const heirarchyObj: any = {};
    heirarchyObj['locName'] = this.queryParams['params']['locName'];
    heirarchyObj['locUUID'] = this.queryParams['params']['pUUID'];
    heirarchyObj['locType'] = this.queryParams['params']['locType'];
    heirarchyObj['component'] = 'VL';
    heirarchyObj['view'] = 'ADMIN';
    heirarchyObj['pEUUID'] = 'cc88f822-8474-48d4-8327-4c85444e4a30';

    return heirarchyObj;
  }

  getHeirarchyData() {
    const heirarchyObj = this.getHeirarchyObj();
    let metaInfo: any = localStorage.getItem('metaInfo')
    let metaInfoJSON = JSON.parse(metaInfo)
    let userlocType;
    if (metaInfoJSON && metaInfoJSON.hasOwnProperty('userDetailsJson') && !isNullOrUndefined(metaInfoJSON.userDetailsJson)) {
      userlocType = metaInfoJSON.userDetailsJson.data.locType
    } else {
      userlocType = 'Country'
    }
    userlocType = userlocType.toUpperCase()
    let userLocHie = LOCATION_HIE
    let locTypeIndex = userLocHie.indexOf(userlocType);
    const hie = userLocHie.slice(locTypeIndex, 3);
    this.dataSrv.getHeirarchy(heirarchyObj).subscribe(data => {
      this.inputForBreadcrumb = [];
      if (!isNullOrUndefined(data) && Object.keys(data).length > 0) {
        data.forEach(element => {
          let obj = {
            locType: element['locType'],
            locationID: element['locationID'],
            locationName: element['ln'],
            locationUUID: element['lUUID'],
            clickable: hie.includes(element['locType'])
          }
          this.inputForBreadcrumb.push(obj);
        });
        this.inputForBreadcrumb = this.inputForBreadcrumb.reverse();
      }
    });
  }

  handleEventFromBreadcrumb(data) {
    // console.log("\n data!!!!",data);
    let currentUrlParams = { ...this.queryParams['params'] }
    let locType = data['selectedLocation']['locType']
    let location = currentUrlParams['location']
    let options = this.updateBreadCrumbOptions(locType, location, currentUrlParams)

    // this.router.navigate(['/heatwatch/heatwave/akbm'], {
    //   relativeTo: this.route,
    //   queryParams: options,
    //   queryParamsHandling: 'merge'
    // })
    // sessionStorage.setItem('params', options)
    this.utils.setSelectedParams(options)
  }

  sortTableByHeatwave() {
    if (!this.stateData || !this.stateData['data'] || !this.stateData['columns']) return;

    // Find first date's Heatwave and SevereHeatwave columns
    const heatwaveCol = this.stateData['columns'][1].find((col: any) => col.val === 'Heatwave');
    const severeCol = this.stateData['columns'][1].find((col: any) => col.val === 'SevereHeatwave' || col.val === 'Severe Heatwave');

    if (!heatwaveCol && !severeCol) return;

    this.stateData['data'] = [...this.stateData['data']].sort((a: any, b: any) => {
      const aHeatwave = parseInt(a[heatwaveCol.sortedHeaderVal].val) || 0;
      const aSevere = parseInt(a[severeCol.sortedHeaderVal].val) || 0;
      const bHeatwave = parseInt(b[heatwaveCol.sortedHeaderVal].val) || 0;
      const bSevere = parseInt(b[severeCol.sortedHeaderVal].val) || 0;
      const aTotal = aHeatwave + aSevere;  
      const bTotal = bHeatwave + bSevere;
      return bTotal - aTotal; // descending
    });
  }
  async getStateData() {
    let heatWaveCount: any
    let locTypes: any;
    if (this.queryParams['params'].locType == 'COUNTRY') {
      heatWaveCount = this.getPostDataForStateHeatWaveCount();
      locTypes = 'Country';
    } else if (this.queryParams['params'].locType == 'STATE') {
      heatWaveCount = this.getPostDataForDistrictHeatWaveCount();
      locTypes = 'State';
    }
    let actualData = this.getPostDataForStateAndDistrictActualData();
    let accuracyData = this.getPostDataForAccuracyData();
    let accuracyDataForCountry = this.getPostDataForAccuracyDataForCountry();
    let heatWatchesCount = this.getPostDataForHeatWatchesCount();
    // Fetching heatWatches forecast data separately so it never blocks the main table rendering
    this.dataSrv.getTableDistrictData(heatWatchesCount).subscribe(
      (hwResponse: any) => {
        this.processHeatWatchesData(hwResponse);
      },
      (err) => {
        console.warn('getHeatWatchesCount failed (getStateData):', err);
      }
    );
    let stateData = new Promise((resolve, reject) => {
      forkJoin(this.dataSrv.getTableDistrictData(heatWaveCount), this.dataSrv.getTableActualData(actualData), this.dataSrv.getTableAccuracyData(accuracyData), this.dataSrv.getTableAccuracyData(accuracyDataForCountry)).subscribe(async (response: any) => {
        // if (response[0] && response[1] && response[2]) {
        if (this.queryParams['params'].locType == 'COUNTRY') {
          // console.log(response[0], response[1], response[2], "response[0], response[1], response[2]")
          this.stateData = this.dataSrv.formatStateData(response[0], response[1], response[2]);
          this.sortTableByHeatwave(); 

          // console.log(this.stateData, "sssssssssssss")
          this.actualData = response[1]
          let mergedChartResponse = this.dataSrv.replaceForecastWithObserved(response[0], response[1])
          let chartWholeData = this.dataSrv.formatChartData(mergedChartResponse, "Heat Wave Band", response[1]);
          if (chartWholeData) {
            this.chartData = chartWholeData[0]
            this.formattedChartData = chartWholeData[1]
            this.blocksArray = chartWholeData[2]
            this.count = chartWholeData[3]
            this.initializeChart();
            this.prepareTableData(this.chartData);
            // this.dataCount.accuracy = this.dataSrv.formatOverallAccuracyData(response[3]);            
            this.hwMapSrv.overallAccuracy = this.dataSrv.formatOverallAccuracyData(response[3])
            this.showSpinner = false
          }
        }
        else if (this.queryParams['params'].locType == 'STATE') {
          this.stateData = this.dataSrv.formatDistrictData(response[0], response[1], response[2]);
          this.sortTableByHeatwave(); 

          let mergedChartResponse = this.dataSrv.replaceForecastWithObserved(response[0], response[1])
          let chartWholeData = this.dataSrv.formatChartData(mergedChartResponse, "Heat Wave Band", response[1]);
          // console.log(chartWholeData, "chartwhole data district");
          if (chartWholeData) {
            this.chartData = chartWholeData[0]
            this.formattedChartData = chartWholeData[1]
            this.blocksArray = chartWholeData[2]
            setTimeout(() => {
              this.initializeChart();
            }, 500);
            this.prepareTableData(this.chartData);
            // this.dataCount.accuracy = this.dataSrv.formatOverallAccuracyData(response[3]);
            this.hwMapSrv.overallAccuracy = this.dataSrv.formatOverallAccuracyData(response[3])
            this.showSpinner = false
          }
        }
        // }
        // let date = this.dataSrv.getCurrentDateInYYYYMMDDFormat();
        // let dates = (this.utils.convertModelDatetoDate(date).toLocaleDateString())
        // this.dataCount.severeHeatwave = (this.formattedChartData[0][dates])
        // this.dataCount.heatWave = (this.formattedChartData[1][dates])
        // this.dataCount.normal = (this.formattedChartData[2][dates])
        // this.dataCount.count = this.dataCount.severeHeatwave + this.dataCount.heatWave + this.dataCount.normal
        // this.utils.heatwaveMetaData.next(this.dataCount)
      }, err => {
        this.showSpinner = false
      })
    })
    await Promise.all([stateData]).then(async (payloads) => {
      let payloadData: any = await payloads[0];
    });
  }

  async getDistrictData() {
    this.forecastDateLabel = '';
    this.heatWatchesMap = {};
    let districtHeatWaveCount: any
    let blockActualData: any;
    let blockAccuracyData: any;
    let heatWaveCount: any;
    let actualData;
    let accuracyDataForCountry;
    if (this.queryParams['params'].locType == 'DISTRICT') {
      districtHeatWaveCount = this.getPostDataForBlockHeatWaveCount();
      blockActualData = this.getPostDataForBlockActualData();
      blockAccuracyData = this.getPostDataForBlockAccuracyData();
      heatWaveCount = this.getPostDataForDistrictHeatWaveCount();
      actualData = this.getPostDataForStateAndDistrictActualData()
      accuracyDataForCountry = this.getPostDataForAccuracyDataForCountry();
    }
    let stateData = new Promise((resolve, reject) => {
      forkJoin(this.dataSrv.getTableBlockHeatWaveData(districtHeatWaveCount), this.dataSrv.getTableBlockActualData(blockActualData), this.dataSrv.getTableAccuracyData(blockAccuracyData), this.dataSrv.getTableDistrictData(heatWaveCount), this.dataSrv.getTableActualData(actualData), this.dataSrv.getTableAccuracyData(accuracyDataForCountry)).subscribe(async (response: any) => {
        this.tableDataMandal = await this.dataSrv.formatMandalDataForTable(response[0], "hwv", "hwc", response[1], response[2]);
        // console.log(this.tableDataMandal, "tableDataMandal");
        // console.log('[HeatWave Table Source] Formatted Mandal Table Data:', this.tableDataMandal);
        let mergedChartResponse = this.dataSrv.replaceForecastWithObserved(response[3], response[4])
        const selectedDistrictUUID = this.queryParams['params']['pUUID'];
        const filteredChartResponse = mergedChartResponse.filter(item => item.uuid === selectedDistrictUUID);
        const filteredActualData = response[4].filter(item => item.uuid === selectedDistrictUUID);

        // let chartWholeData = this.dataSrv.formatChartData(response[3], "Heat Wave Band", response[4]);

        let chartWholeData = this.dataSrv.formatChartData(filteredChartResponse, "Heat Wave Band", filteredActualData);
        // console.log(chartWholeData, "chartwhole data block");

        if (chartWholeData) {
          // this.formattedChartData = chartWholeData[1]
          this.chartData = chartWholeData[0]
          let allLocations = this.queryParams['params']['location']
          let locationStr = allLocations.split('&')[1]
          let stateUUID = locationStr.split('##')[1]
          setTimeout(() => {
            this.initializeChart();
          }, 500);
          this.prepareTableData(this.chartData);
          this.dataCount.accuracy = this.dataSrv.formatOverallAccuracyData(response[5]);
          this.hwMapSrv.overallAccuracy = this.dataSrv.formatOverallAccuracyData(response[5]);
          this.showSpinner = false
        }
        // let date = this.dataSrv.getCurrentDateInYYYYMMDDFormat();
        // let dates = (this.utils.convertModelDatetoDate(date).toLocaleDateString())
        // this.dataCount.severeHeatwave = (this.formattedChartData[0][dates])
        // this.dataCount.heatWave = (this.formattedChartData[1][dates])
        // this.dataCount.normal = (this.formattedChartData[2][dates])
        // this.dataCount.count = this.dataCount.severeHeatwave + this.dataCount.heatWave + this.dataCount.normal
        // console.log("dataCount",this.dataCount);

        // this.utils.heatwaveMetaData.next(this.dataCount)
      }, err => {
        this.showSpinner = false
      })
    })
    await Promise.all([stateData]).then(async (payloads) => {
      let payloadData: any = await payloads[0];
    });
  }
  getPostDataForHeatWatchesCount() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    const startTs = yesterday.getTime();
    const endTs = this.queryParams['params']['source'] != 'ECMWF'
      ? today.getTime() + (6 * 24 * 60 * 60 * 1000)
      : today.getTime() + (14 * 24 * 60 * 60 * 1000);

    const locType = this.queryParams['params']['locType'];
    const source = this.queryParams['params']['source'];
    const locationStr = this.queryParams['params']['location'];

    let sUUID: any;
    let pUUID: any;
    let pType: any;
    let cType: any;
    let countLocationType: any;

    if (locType === 'COUNTRY') {
      // COUNTRY: show state-level breakdown, count at BLOCK level
      sUUID = '00cb31c7-2928-4e6d-adcc-443d478c90d6';
      pUUID = '00cb31c7-2928-4e6d-adcc-443d478c90d6';
      pType = 'COUNTRY';
      cType = 'STATE';
      // countLocationType = this.selectedViewType//'BLOCK';
      countLocationType = this.getTableCountLocationType(cType)//'BLOCK';
    } else if (locType === 'STATE') {
      // STATE: show district-level breakdown, count at BLOCK level
      const stateUUID = locationStr.split('&')[1].split('##')[1];
      sUUID = stateUUID;
      pUUID = stateUUID;
      pType = 'STATE';
      cType = 'DISTRICT';
      // countLocationType = this.selectedViewType//'BLOCK';
      countLocationType = this.getTableCountLocationType(cType)//'BLOCK';
    } else if (locType === 'DISTRICT') {
      // DISTRICT: show block-level breakdown
      // NOTE: countLocationType is intentionally omitted — it causes a 500 from the API
      const locationParts = locationStr.split('&');
      const stateUUID = locationParts[1].split('##')[1];
      const districtUUID = locationParts[2].split('##')[1];
      sUUID = stateUUID;
      pUUID = districtUUID;
      pType = 'DISTRICT';
      cType = 'BLOCK';
      return { component: 'HEATWAVE', sUUID, pUUID, pType, cType, source, startTs, endTs };
    }

    return { component: 'HEATWAVE', sUUID, pUUID, pType, cType, countLocationType, source, startTs, endTs };
  }

  getPostDataForStateHeatWaveCount() {
    const today = new Date();
    const startTs = today.getTime() - (2 * 24 * 60 * 60 * 1000);
    const endTs = this.queryParams['params']['source'] != 'ECMWF' ? today.getTime() + (6 * 24 * 60 * 60 * 1000) : today.getTime() + (14 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let postData: any = {
      component: "HEATWAVE",
      "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      "pType": "COUNTRY",
      "cType": "STATE",
      // "countLocationType": "DISTRICT",
      "countLocationType": this.selectedViewType,
      "source": this.queryParams['params']['source'],
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForDistrictHeatWaveCount() {
    let locationStr = this.queryParams['params'].location;
    let locationParts = locationStr.split('&')[1];
    let stateUUID = locationParts.split('##')[1]
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = this.queryParams['params'].locType != 'DISTRICT' ? hie[hie.indexOf(this.queryParams['params'].locType) + 1] : this.queryParams['params'].locType;
    let firstLevel: any = this.queryParams['params'].locType != 'DISTRICT' ? hie[hie.indexOf(this.queryParams['params'].locType) + 2] : hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    const today = new Date();
    const startTs = today.getTime() - (2 * 24 * 60 * 60 * 1000);
    const endTs = this.queryParams['params']['source'] != 'ECMWF' ? today.getTime() + (6 * 24 * 60 * 60 * 1000) : today.getTime() + (14 * 24 * 60 * 60 * 1000);
    let postData: any = {
      "pUUID": stateUUID,
      "sUUID": stateUUID,
      "pType": this.queryParams['params'].locType != 'DISTRICT' ? this.queryParams['params'].locType : hie[hie.indexOf(this.queryParams['params'].locType) - 1],
      "cType": currentLevel,
      "component": "HEATWAVE",
      // "countLocationType": this.selectedViewType,//firstLevel,
      "countLocationType": this.getTableCountLocationType(currentLevel),//firstLevel,
      "source": this.queryParams['params']['source'],
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForBlockHeatWaveCount() {
    let locationStr = this.queryParams['params'].location;
    let locationParts1 = locationStr.split('&')[1];
    let locationParts2 = locationStr.split('&')[2];
    let stateUUID = locationParts1.split('##')[1];
    let districtUUID = locationParts2.split('##')[1];
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let firstLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) - 1];
    const today = new Date();
    const startTs = today.getTime() - (2 * 24 * 60 * 60 * 1000);
    const endTs = this.queryParams['params']['source'] != 'ECMWF' ? today.getTime() + (6 * 24 * 60 * 60 * 1000) : today.getTime() + (14 * 24 * 60 * 60 * 1000);
    let postData = {
      "component": "HEATWAVE",
      "sUUID": stateUUID,
      "pUUID": districtUUID,
      "pType": this.queryParams['params']['locType'],
      "cType": currentLevel,
      "source": this.queryParams['params']['source'],
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForStateAndDistrictActualData() {
    let allLocations = this.queryParams['params']['location']
    let stateUUID;
    if (this.queryParams['params']['locType'] == 'DISTRICT') {
      let locationStr = allLocations.split('&')[1]
      stateUUID = locationStr.split('##')[1]
    }
    const today = new Date();
    const startTs = today.getTime() - (2 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = this.queryParams['params'].locType != 'DISTRICT' ? hie[hie.indexOf(this.queryParams['params'].locType) + 1] : this.queryParams['params'].locType;
    let firstLevel: any = this.queryParams['params'].locType != 'DISTRICT' ? hie[hie.indexOf(this.queryParams['params'].locType) + 2] : hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let postData = {
      "component": "HEATWAVE",
      "sUUID": this.queryParams['params'].locType != 'DISTRICT' ? this.queryParams['params'].pUUID : stateUUID,
      "pUUID": this.queryParams['params'].locType != 'DISTRICT' ? this.queryParams['params'].pUUID : stateUUID,
      "pType": this.queryParams['params'].locType != 'DISTRICT' ? this.queryParams['params']['locType'] : hie[hie.indexOf(this.queryParams['params'].locType) - 1],
      "cType": currentLevel,
      // "countLocationType": firstLevel,
      // "countLocationType": this.selectedViewType,//this.queryParams['params'].locType == 'COUNTRY' ? 'BLOCK' : firstLevel,
      "countLocationType": this.getTableCountLocationType(currentLevel),//this.queryParams['params'].locType == 'COUNTRY' ? 'BLOCK' : firstLevel,
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForBlockActualData() {
    let locationStr = this.queryParams['params'].location;
    let locationParts1 = locationStr.split('&')[1];
    let locationParts2 = locationStr.split('&')[2];
    let stateUUID = locationParts1.split('##')[1];
    let districtUUID = locationParts2.split('##')[1];
    const today = new Date();
    const startTs = today.getTime() - (2 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) - 1];
    let firstLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let postData = {
      "component": "HEATWAVE",
      "sUUID": stateUUID,
      "pUUID": districtUUID,
      "pType": this.queryParams['params'].locType,
      "cType": firstLevel,
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForAccuracyData() {
    const today = new Date();
    const startTs = today.getTime() - (2 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let firstLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 2];
    let postData = {
      "component": "HEATWAVE",
      "sUUID": this.queryParams['params']['pUUID'],
      "pUUID": this.queryParams['params']['pUUID'],
      "timePeriod": 'LASTKNOWN',
      "pType": this.queryParams['params']['locType'],
      "cType": currentLevel,
      "sourceType": this.queryParams['params']['source'] != 'ECMWF' ? 'IMD' : 'ECMWF',
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForAccuracyDataForCountry() {
    let locationStr = this.queryParams['params'].location;
    let stateUUID;
    if (this.queryParams['params']['locType'] == 'DISTRICT') {
      let locationParts = locationStr.split('&')[1];
      stateUUID = locationParts.split('##')[1];
    }
    const today = new Date();
    const startTs = today.getTime() - (2 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let postData = {
      "component": "HEATWAVE",
      "sUUID": this.queryParams['params']['locType'] != 'DISTRICT' ? this.queryParams['params']['pUUID'] : stateUUID,
      "pUUID": this.queryParams['params']['locType'] != 'DISTRICT' ? this.queryParams['params']['pUUID'] : stateUUID,
      "timePeriod": 'LASTKNOWN',
      "pType": this.queryParams['params']['locType'] != 'DISTRICT' ? this.queryParams['params']['locType'] : hie[hie.indexOf(this.queryParams['params'].locType) - 1],
      "cType": this.queryParams['params']['locType'] != 'DISTRICT' ? this.queryParams['params']['locType'] : hie[hie.indexOf(this.queryParams['params'].locType) - 1],
      "sourceType": this.queryParams['params']['source'] != 'ECMWF' ? 'IMD' : 'ECMWF',
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getPostDataForBlockAccuracyData() {
    let locationStr = this.queryParams['params'].location;
    let locationParts = locationStr.split('&')[1];
    let stateUUID = locationParts.split('##')[1];

    const today = new Date();
    const startTs = today.getTime() - (2 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) - 1];
    let firstLevel: any = hie[hie.indexOf(this.queryParams['params'].locType) + 1];
    let postData = {
      "component": "HEATWAVE",
      "sUUID": stateUUID,
      "pUUID": stateUUID,
      "timePeriod": 'LASTKNOWN',
      "pType": currentLevel,
      "cType": firstLevel,
      "sourceType": this.queryParams['params']['source'] != 'ECMWF' ? 'IMD' : 'ECMWF',
      "startTs": startTs,
      "endTs": endTs
    }
    return postData;
  }

  getTextColor(bg: string): string {
    const darkColors = ['#B22222'];
    return darkColors.includes(bg) ? '#B22222' : '#ff7c00 ';
  }

  onStateClick(row: any) {
    let options: any = { ...this.queryParams };
    let allLocations: any = this.queryParams['params']['location'].split('&');
    this.onLocationClick(row, allLocations, options['params']);
  }

  onLocationClick(row: any, allLocations: any, options: any) {
    let mergeOptions = this.updateOptions(row, allLocations, options);
    // this.router.navigate(['/heatwatch/heatwave/akbm'], {
    //   relativeTo: this.route,
    //   queryParams: options,
    //   queryParamsHandling: 'merge'
    // });
    // sessionStorage.setItem('params', mergeOptions)
    this.utils.setSelectedParams(mergeOptions)
  }

  updateOptions(row: any, allLocations: any, options: any) {
    const stateKeys = Object.keys(row);
    const stateKey = stateKeys.find(k => k === "State");
    let stateName: any;
    let districtName: any;
    if (this.queryParams['params'].locType == 'COUNTRY') {
      stateName = row['State'].val;
    } else if (this.queryParams['params'].locType == 'STATE') {
      districtName = row['District'].val;
    }
    if (row['uuid'] && this.queryParams['params'].locType == 'COUNTRY') {
      options['locType'] = 'STATE';
      options['pUUID'] = row['uuid'];
      options['locName'] = this.utils.titleCase(stateName);
      options['location'] = allLocations[0] + '&' + this.utils.titleCase(stateName) + '##' + row['uuid'];
    } else if (row['uuid'] && this.queryParams['params'].locType == 'STATE') {
      options['locType'] = 'DISTRICT';
      options['pUUID'] = row['uuid'];
      options['locName'] = this.utils.titleCase(districtName);
      options['location'] = allLocations[0] + '&' + allLocations[1] + '&' + this.utils.titleCase(districtName) + '##' + row['uuid'];
    }
    return options;
  }

  // resetBreadcrumb(locType: any) {
  //   let options: any = { ...this.queryParams };
  //   let allLocations: any = this.queryParams['params']['location'].split('&');
  //   this.onLocationBreadCrumbClick(locType, allLocations, options);
  // }

  // onLocationBreadCrumbClick(locType, allLocations, options) {
  //   let mergeOptions = this.updateBreadCrumbOptions(locType, allLocations, options);
  //   this.router.navigate(['/heatwatch/heatwave/akbm'], {
  //     relativeTo: this.route,
  //     queryParams: options,
  //     queryParamsHandling: 'merge'
  //   });
  // }

  updateBreadCrumbOptions(locType, allLocations, options) {
    let location;
    if (locType == 'COUNTRY') {
      location = allLocations.split('&')[0]
      options['locType'] = 'COUNTRY'
      options['locName'] = location.split('##')[0]
      options['location'] = allLocations.split('&')[0]
      options['pUUID'] = location.split('##')[1]
    } else if (locType == 'STATE') {
      location = allLocations.split('&')[1]
      options['locType'] = 'STATE'
      options['locName'] = location.split('##')[0]
      options['location'] = allLocations.split('&')[0] + '&' + allLocations.split('&')[1]
      options['pUUID'] = location.split('##')[1]
    }
    // else {
    //   location = allLocations.split('&')[0] + '&' + allLocations.split('&')[1] + '&' + allLocations.split('&')[2]
    // }
    return options
  }

  initializeChart(): void {
    if (!this.chartData || !this.chartData.Normal || !this.chartData.Heatwave || !this.chartData.SevereHeatwave) {
      // console.warn('Chart data is not properly defined');
      return;
    }
    const categories = Object.keys(this.chartData.Normal || {});
    let chartData = this.dataSrv.getChartData(categories, this.chartData, this.queryParams['params']);
    this.highcharts.chart(this.container.nativeElement, chartData)
  }

  onButtonClick(view: 'chart' | 'table') {
    this.showChart = view === 'chart';
  }

  toggleTableChart() {
    this.showChart = !this.showChart
    if (this.showChart) {
      setTimeout(() => {
        this.initializeChart()
      }, 200)
    }
  }

  prepareTableData(data: any) {
    this.dates = Object.keys(data.SevereHeatwave);
    const categoryColors: { [key: string]: string } = {
      'Severe Heatwave': '#B22222',
      'Heatwave': '#FFA500',
      'Normal': '#9edbab'
    };
    this.tableRows = Object.keys(data).map((category) => {
      const displayName = category === 'SevereHeatwave' ? 'Severe Heatwave' : category;
      return {
        category: displayName,
        color: categoryColors[displayName],
        values: this.dates.map(date => data[category][date] !== undefined ? data[category][date] : 0)
      };
    });
  }
  //  processHeatWatchesData(data: any[]) {
  //   this.heatWatchesMap = {};
  //   this.forecastDateLabel = '';
  //   if (!data || !Array.isArray(data) || data.length === 0) { return; }
  //   // Determine yesterday's timestamp as YYYYMMDD number
  //   const today = new Date();
  //   const yesterday = new Date(today);
  //   yesterday.setDate(today.getDate() - 1);
  //   const y = yesterday.getFullYear();
  //   const m = (yesterday.getMonth() + 1).toString().padStart(2, '0');
  //   const d = yesterday.getDate().toString().padStart(2, '0');
  //   const yesterdayTs = Number(`${y}${m}${d}`);
  //   // Format the display label e.g. "25/03/2026"
  //   this.forecastDateLabel = `${d}/${m}/${y}`;
  //   data.forEach((item: any) => {
  //     if (!item || !item.uuid || !Array.isArray(item.table_data)) { return; }
  //     const entry = item.table_data.find((td: any) => Number(td.timeStamp) === yesterdayTs);
  //     if (entry && entry.data) {
  //       this.heatWatchesMap[item.uuid] = {
  //         heatwave: entry.data['c'] != null ? entry.data['c'] : 0,
  //         severeHeatwave: entry.data['d'] != null ? entry.data['d'] : 0
  //       };
  //     } else {
  //       this.heatWatchesMap[item.uuid] = { heatwave: 0, severeHeatwave: 0 };
  //     }
  //   });
  // }

  processHeatWatchesData(data: any[]) {
    this.heatWatchesMap = {};
    this.forecastDateLabel = '';
    if (!data || !Array.isArray(data) || data.length === 0) { return; }

    // Determine the shifted "Today" timestamp using the service's logic
    const todayYYYYMMDD = this.dataSrv.getCurrentDateInYYYYMMDDFormat();
    const todayTs = Number(todayYYYYMMDD);

    // Extract day, month, year for the display label from YYYYMMDD
    const yStr = todayYYYYMMDD.substring(0, 4);
    const mStr = todayYYYYMMDD.substring(4, 6);
    const dStr = todayYYYYMMDD.substring(6, 8);
    this.forecastDateLabel = `${dStr}/${mStr}/${yStr}`;

    data.forEach((item: any) => {
      if (!item || !item.uuid || !Array.isArray(item.table_data)) { return; }
      const entry = item.table_data.find((td: any) => Number(td.timeStamp) === todayTs);
      if (entry && entry.data) {
        this.heatWatchesMap[item.uuid] = {
          heatwave: entry.data['c'] != null ? entry.data['c'] : 0,
          severeHeatwave: entry.data['d'] != null ? entry.data['d'] : 0
        };
      } else {
        this.heatWatchesMap[item.uuid] = { heatwave: 0, severeHeatwave: 0 };
      }
    });
  }
  getOverallAccuracyDataForState(actualData, stateUUID) {
    this.dataCount.accuracy = this.dataSrv.getOverallAccuracyDataForState(actualData, stateUUID);
  }

  setLastLevelTableData() {
    this.utils.getTimeStamp().subscribe(async date => {
      if (date) {
        let blockNumber = this.dataSrv.setBlockNumber()
        if (blockNumber == 3) {
          // date = date + 1
        }
        this.selectedTimeStamp = date.toString()
        if (!isNullOrUndefined(this.hwCountTableData) && !isNullOrUndefined(this.hwCatagoryTableData)) {
          this.getHWCountTableData(this.hwCountTableData)
          this.getHWCategoryTableData(this.hwCatagoryTableData)
        }
      }
    })
    this.utils.schoolCheckBoxClicked.subscribe(data => {
      // this.getSchoolAlertCount();
      if (!isNullOrUndefined(data)) {
        if (data) {
          this.type = 'Schools'
          this.getCategoryCount('SCHOOL');
          this.getHeatWaveCount('SCHOOL');
        }
      } else {
        this.showLastLevelTable = false
      }
    });
    this.utils.CheckBoxAngaClicked.subscribe(data => {
      if (!isNullOrUndefined(data)) {
        if (data) {
          this.type = 'Anganwadis'
          this.getHeatWaveCount('ANGANWADI');
        } else {
          this.showLastLevelTable = false
        }
      }
    });
    this.utils.CheckBoxHealthCareClicked.subscribe(data => {
      if (!isNullOrUndefined(data)) {
        if (data) {
          this.type = 'Healthcares'
          this.getCategoryCount('HEALTHCARE');
          this.getHeatWaveCount('HEALTHCARE');
        } else {
          this.showLastLevelTable = false
        }
      }
    });
  }


  // getStartEndTS() {
  //   let timestampObj = {}
  //   let blockNumber = this.dataSrv.setBlockNumber()
  //   const now = new Date();
  //   let startTs;
  //   let endDate;

  //   // Start of today (00:00:00)
  //   if (blockNumber == 2) {
  //     startTs = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).getTime();
  //     endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 5);
  //   } else {
  //     startTs = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  //     endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 6);
  //   }

  //   // End of 7 days from now (23:59:59)
  //   endDate.setHours(23, 59, 59, 999);
  //   let endTs = endDate.getTime();
  //   timestampObj['startTs'] = startTs
  //   timestampObj['endTs'] = endTs
  //   return timestampObj
  // }

  getStartEndTS(source?) {
    const timestampObj = {};
    const now = new Date();

    // Start from D-2 to align with the playbar start date
    const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2);
    startDate.setHours(0, 0, 0, 0);
    const startTs = startDate.getTime();

    // End after 8 days for IMD-GFS (to reach 21st if today is 13th), and 13 days for ECMWF 
    let daysToAdd = source === 'ECMWF' ? 13 : 8;
    const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysToAdd);
    endDate.setHours(23, 59, 59, 999);
    const endTs = endDate.getTime();

    timestampObj['startTs'] = startTs;
    timestampObj['endTs'] = endTs;
    return timestampObj;
  }

  getPopulationExposureData() {
    const params = this.queryParams['params'];
    const locType = params['locType'];
    const pUUID = params['pUUID'];
    const locationStr = params['location'] || '';
    const source = params['source'];
    const timeRange: any = this.getStartEndTS(source);

    let postData: any = {
      src: source,
      startTs: timeRange['startTs'],
      endTs: timeRange['endTs'],
      component: 'HEATWAVE'
    };

    if (locType === 'COUNTRY') {
      postData.pType = 'COUNTRY';
      postData.parentUUID = pUUID;
      postData.UUID = pUUID;
      postData.cType = this.selectedViewType;
    } else if (locType === 'STATE') {
      postData.pType = 'STATE';
      postData.parentUUID = pUUID;
      postData.UUID = pUUID;
      postData.cType = this.selectedViewType;
    } else if (locType === 'DISTRICT') {
      // For DISTRICT level, parentUUID is the State UUID
      const locationParts = locationStr.split('&');
      const stateUUID = locationParts[1] ? locationParts[1].split('##')[1] : pUUID;
      postData.pType = 'DISTRICT';
      postData.parentUUID = stateUUID;
      postData.UUID = pUUID;
      postData.cType = 'BLOCK';
    } else {
      // Default fallback if locType is unknown (e.g. BLOCK)
      postData.pType = locType;
      postData.parentUUID = pUUID;
      postData.UUID = pUUID;
      postData.cType = 'BLOCK';
    }

    // console.log('Population Exposure API Payload:', postData);

    this.dataSrv.getPopulationExposure(postData).subscribe(
      (response: any) => {
        console.log('Population Exposure API Response:', response);
        this.populationExposureData = response && response.data ? response.data : null;
        this.updatePopExposureForDate();
      },
      (error: any) => {
        console.error('Population Exposure API Error:', error);
      }
    );
  }

  updatePopExposureForDate() {
    if (!this.populationExposureData || !this.selectedTimeStamp) {
      return;
    }

    const dateKey = this.selectedTimeStamp.toString();
    const dayData = this.populationExposureData[dateKey];
    if (!dayData || !dayData.categories) {
      this.popExposureForDate = { normal: 0, heat_waves: 0, severe_heat_waves: 0 };
      return;
    }
    const cats = dayData.categories;
    this.popExposureForDate = {
      normal: cats.normal ? cats.normal.percent : 0,
      heat_waves: cats.heat_waves ? cats.heat_waves.percent : 0,
      severe_heat_waves: cats.severe_heat_waves ? cats.severe_heat_waves.percent : 0
    };
  }

  getHeatWaveCount(type) {
    let locationStr = this.queryParams['params'].location;
    let locationParts1 = locationStr.split('&')[1];
    let stateUUID = locationParts1.split('##')[1];
    let locationParts2 = locationStr.split('&')[2]
    let districtUUID = locationParts2.split('##')[1];
    let timestampObj = this.getStartEndTS(this.queryParams['params']['source'])
    this.hwCountTableData = {}
    const postData = {
      "stateUUID": stateUUID,
      "pUUID": districtUUID,
      "pType": "DISTRICT",
      "cType": "BLOCK",
      "locType": type,
      "source": this.queryParams['params']['source'],
      "startTs": timestampObj['startTs'],
      "endTs": timestampObj['endTs'],
      "component": "heatwave"
    }
    this.utils.getSchoolHeatWaveCategoryCount(postData).subscribe(data => {
      this.categoryList = {};
      this.hwCountTableData = data
      this.showLastLevelTable = true
      this.getHWCountTableData(data)
    });
  }

  getHWCountTableData(data) {
    const districtData = data[this.selectedTimeStamp];
    const districtUUID = districtData ? Object.keys(districtData)[0] : null;
    if (districtData && districtData[this.queryParams['params']['pUUID']]) {
      this.categoryList = districtData[districtUUID];
      this.totalCategoryCount = 0
      Object.keys(this.categoryList).forEach(key => {
        this.totalCategoryCount += this.categoryList[key]
      })
    } else {
      this.categoryList = {
        normal: '-',
        severe_heat_waves: '-',
        heat_waves: '-'
      };
    }
    // console.log("this.categoryList", this.categoryList);
  }

  getCategoryCount(type) {
    let locationStr = this.queryParams['params'].location;
    let locationParts1 = locationStr.split('&')[1];
    let stateUUID = locationParts1.split('##')[1];
    let locationParts2 = locationStr.split('&')[2]
    let districtUUID = locationParts2.split('##')[1];
    const now = new Date();
    const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const timestamp = todayMidnight.getTime();
    const timestamps = timestamp;
    const date = new Date(timestamps);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const day = date.getDate().toString().padStart(2, '0');
    const timestampStr = `${year}${month}${day}`;
    let timestampObj = this.getStartEndTS(this.queryParams['params']['source'])
    this.hwCatagoryTableData = {}

    const postData = {
      "stateUUID": stateUUID,
      "pUUID": districtUUID,
      "src": this.queryParams['params']['source'],
      "cType": "BLOCK",
      "startTs": timestampObj['startTs'],
      "endTs": timestampObj['endTs'],
      "locType": type,
      "component": "heatwave"
    }
    this.utils.getSchooleAlertCount(postData).subscribe(data => {
      this.hwCatagoryTableData = data
      this.getHWCategoryTableData(data)
    });
  }

  getHWCategoryTableData(data) {
    const dateLevelData = data[this.selectedTimeStamp];
    if (dateLevelData) {
      const uuid = Object.keys(dateLevelData)[0]; // Get the first UUID key
      const categoryData = dateLevelData[uuid];

      if (categoryData) {
        this.filteredData = {
          normal: categoryData.normal || {},
          heat_waves: categoryData.heat_waves || {},
          severe_heat_waves: categoryData.severe_heat_waves || {}
        };
      } else {
        this.filteredData = {
          normal: {},
          heat_waves: {},
          severe_heat_waves: {}
        };
      }
      // console.log(this.filteredData, "filteredData")
    } else {
      this.filteredData = {
        normal: {},
        heat_waves: {},
        severe_heat_waves: {}
      };
    }
    this.categoryTypes = Array.from(new Set([
      ...Object.keys(this.filteredData.normal || {}),
      ...Object.keys(this.filteredData.heat_waves || {}),
      ...Object.keys(this.filteredData.severe_heat_waves || {})
    ]));
    // console.log("this.categoryTypes", this.categoryTypes);
  }

  hasAnyData(category: string): boolean {
    return (
      (this.filteredData.normal && this.filteredData.normal[category] != null) ||
      (this.filteredData.heat_waves && this.filteredData.heat_waves[category] != null) ||
      (this.filteredData.severe_heat_waves && this.filteredData.severe_heat_waves[category] != null)
    );
  }

  openAccuracyPopup() {
    let locationStr = this.queryParams['params'].location;
    let locationParts = this.queryParams['params']['locType'] != 'COUNTRY' ? locationStr.split('&')[1] : locationStr.split('&')[0];
    let stateUUID = locationParts.split('##')[1];
    let locName = this.queryParams['params']['locType'] != 'DISTRICT' ? this.queryParams['params']['locName'] : locationParts.split('##')[0]
    const modalRef = this.modalService.open(AccuracyPopupDataTableComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'modal-dark size-large',
      backdrop: 'static'
    });
    // modalRef.componentInstance.title = title;
    modalRef.componentInstance.queryParams = this.queryParams['params']
    modalRef.componentInstance.selectedState = locName
    modalRef.componentInstance.stateUUID = stateUUID
    modalRef.componentInstance.locType = this.queryParams['params']['locType']
  }

  infoclick(value) {
    const modalRef = this.modalService.open(InfomodalComponent, { backdrop: 'static', keyboard: true, windowClass: 'backgroundTransparent  infocomponent' })
    modalRef.componentInstance.selected = value;
    modalRef.componentInstance.locType = this.selectedLocType;
  }

  closePanel() {
    if (this.gisMapComp.dataTabToggleVal) {
      this.gisMapComp.dataTabToggle();
    }
  }

  // exportexcel() {
  //   const element = document.getElementById('gis-table');
  //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  //   this.selectedSource = this.queryParams['params']['source'] != 'ECMWF' ? 'IMD' : 'ECMWF'
  //   let sourceText: any;
  //   sourceText = ['Source: ' + this.selectedSource];
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //   const newWs: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([sourceText, []]);
  //   const originalData = XLSX.utils.sheet_to_json(ws, { header: 1 }) as string[][];
  //   XLSX.utils.sheet_add_aoa(newWs, originalData, { origin: 'A3' });
  //   XLSX.utils.book_append_sheet(wb, newWs, 'Sheet1');
  //   let fileName: any;
  //   fileName = `${this.selectedComponent}_${this.selectedSource}.xlsx`;
  //   XLSX.writeFile(wb, fileName);
  // }

  exportexcel() {
    const element = document.getElementById('gis-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    this.selectedSource = this.queryParams['params']['source'] != 'ECMWF' ? 'IMD' : 'ECMWF';
    const sourceText: any = ['Source: ' + this.selectedSource];
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const newWs: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([sourceText, []]);
    const originalData = XLSX.utils.sheet_to_json(ws, {
      header: 1,
      raw: false,
      dateNF: 'dd/mm/yyyy'
    }) as string[][];
    XLSX.utils.sheet_add_aoa(newWs, originalData, { origin: 'A3' });
    // const footerText: any = [[''], ['For more information, visit www.metwise.vassarlabs.com']];
    // XLSX.utils.sheet_add_aoa(newWs, footerText, { origin: -1 });
    XLSX.utils.book_append_sheet(wb, newWs, 'Sheet1');
    const fileName = `${this.selectedComponent}_${this.selectedSource}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  async downloadBothTablesAsPdf() {
    if (this.isPdfDownloading) { return; }
    this.selectedSource = this.queryParams['params']['source'] !== 'ECMWF' ? 'IMD' : 'ECMWF';
    const summaryEl = document.getElementById('summary-table');
    const categoryEl = document.getElementById('category-table');
    if (!summaryEl || !categoryEl) { return; }

    this.isPdfDownloading = true;
    try {
      // Yield once so the button spinner renders before html2canvas blocks the UI thread
      await new Promise(resolve => setTimeout(resolve));

      const scale = 2;
      const summaryCanvas = await html2canvas(summaryEl, { scale, useCORS: true });
      const categoryCanvas = await html2canvas(categoryEl, { scale, useCORS: true });

      const pageWidth = 210;  // A4 mm
      const margin = 10;
      const usableWidth = pageWidth - margin * 2;

      const summaryH = (summaryCanvas.height * usableWidth) / summaryCanvas.width;
      const categoryH = (categoryCanvas.height * usableWidth) / categoryCanvas.width;

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageHeight = pdf.internal.pageSize.height;

      // Header
      pdf.setFontSize(12);
      pdf.setTextColor(40);
      pdf.text(`Heatwave Category Distribution - ${this.type}`, margin, margin + 4);
      pdf.setFontSize(9);
      pdf.setTextColor(100);
      pdf.text(`Source: ${this.selectedSource}`, margin, margin + 10);

      let yPos = margin + 16;

      // Summary table image
      pdf.addImage(summaryCanvas.toDataURL('image/png'), 'PNG', margin, yPos, usableWidth, summaryH);
      yPos += summaryH + 6;

      // Page break if needed
      if (yPos + categoryH > pageHeight - margin) {
        pdf.addPage();
        yPos = margin;
      }

      // Category table image
      pdf.addImage(categoryCanvas.toDataURL('image/png'), 'PNG', margin, yPos, usableWidth, categoryH);

      // Footer — placed right below the category table (dynamic)
      const footerY = yPos + categoryH + 8;
      const footerFontSize = 9;
      pdf.setFontSize(footerFontSize);

      const prefix = 'For more information, visit ';
      const urlText = 'www.metwise.vassarlabs.com';

      // Plain dark prefix
      pdf.setTextColor(60);
      pdf.text(prefix, margin, footerY);

      // Measure prefix width so URL sits right after it
      const prefixWidth = pdf.getStringUnitWidth(prefix) * footerFontSize / (72 / 25.4);

      // Blue URL text
      pdf.setTextColor(5, 99, 193);
      pdf.text(urlText, margin + prefixWidth, footerY);

      // Clickable link rectangle over the URL text only
      const urlWidth = pdf.getStringUnitWidth(urlText) * footerFontSize / (72 / 25.4);
      pdf.link(margin + prefixWidth, footerY - 4, urlWidth, 5, { url: 'https://metwise.vassarlabs.com/' });

      pdf.save(`Category_Distribution_${this.selectedSource}.pdf`);
    } finally {
      this.isPdfDownloading = false;
    }
  }

  downloadHWReport() {
    this.dataSrv.heatWaveReport(this.gisMapComp)
  }

  // The count APIs return 500 when countLocationType equals cType (e.g. DISTRICT view at STATE level),
  // so count one level deeper instead — same rule as tableCountLocationType in HeatindexInfoboxComponent
  getTableCountLocationType(cType: string) {
    const hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    return this.selectedViewType === cType ? hie[hie.indexOf(cType) + 1] : this.selectedViewType;
  }

  async onViewTypeChange(type: any) {
    if (this.selectedViewType == type) return
    this.selectedViewType = type
    // Store the level on the params (same as Heat Index) so source change, breadcrumb and drilldown carry it forward
    this.queryParams['params']['viewType'] = type
    if (this.gisMapComp.params) {
      this.gisMapComp.params['viewType'] = type
    }
    const currentParams = JSON.parse(sessionStorage.getItem('params') || '{}');
    currentParams.viewType = type;
    sessionStorage.setItem('params', JSON.stringify(currentParams));
    if (this.queryParams['params']['locType'] == 'COUNTRY') {
      this.showSpinner = true
      this.getStateData()
    }
    this.getPopulationExposureData()
    this.hwMapSrv.updateHeaderCounts()
    this.hwMapSrv.setHeatwavePlaybarChartData(this.gisMapComp, this.queryParams['params'], this.selectedViewType)
    this.hwMapSrv.switchAdminLevel(this.gisMapComp)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
